import axios from 'axios';
import type { FontManifest, JobFontsDisplayModel } from './types';

/**
 * Anonymous font endpoints only. Deliberately plain `axios` with no `@shared/axios` import so the
 * font loader stays free of the app's auth layer (and of its transitive dependencies in tests).
 * The studio-admin call lives in `jobFonts.studio.service.ts`.
 */

export const FONT_MANIFEST_URL = '/api/public/fonts/manifest';

/** The manifest is public so consumer galleries can load it without a session. */
export const fetchFontManifest = async (): Promise<FontManifest> =>
  (await axios.get<FontManifest>(FONT_MANIFEST_URL)).data;

/** Font names a consumer job's package sets reference (all of them: the preload wants the superset). */
export const fetchJobFonts = async (jobId: number | string): Promise<string[]> => {
  const response = await axios.get<JobFontsDisplayModel>(`/api/customer/jobs/${jobId}/fonts`);
  return response.data.fonts ?? [];
};
